import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import Visibility from "@mui/icons-material/Visibility";
import TouchApp from "@mui/icons-material/TouchApp";

// core components
import Grid from "@mui/material/Grid";

import OthelloBotonera from '../componentsothello/OthelloBotonera.jsx';
import { DataStatePage, TipoOthelloFieldGrid, Roles, PopUpResult, DataStateModal, ModoModal, MessageOthelloBoxButtons, TiposPeticion, TipoPeticion } from "../othelloConstantes.jsx";
import OthelloGrid from '../componentsothello/OthelloGrid.jsx';


import OthelloPopUpResult from "../componentsothello/OthelloPopUpResult.jsx";
import OthelloModalBase from '../componentsothello/OthelloModalBase.jsx';

import Peticion from './Peticion.js';
import OthelloTituloPanelData from "../componentsothello/OthelloTituloPanelData.jsx";


export default function Peticiones({ ...props }) {
    const { literal, idRol } = props;

    const [loading, setLoading] = React.useState(true);

    const [statePage, setstatePage] = React.useState(DataStatePage.dsDesconocido);
    const [datapeticiones, setdatapeticiones] = React.useState(null);

    const [alert, setalert] = React.useState(null);

    const [stateModal, setstateModal] = React.useState(DataStateModal.dsClosed);
    const [itemmodal, setitemmodal] = React.useState(null);
    const [modomodal, setmodomodal] = React.useState(null);

    const [dataeditando, setdataeditando] = useState(null);
    const [indexeditando, setindexeditando] = useState(null);

    const navigate = useNavigate();

    const location = useLocation();

    React.useEffect(() => {

        setLoading(false);
        getDataPage();
    }, [loading]);

    //METODOS GLOBALES DE LA PAGINA

    const getDataPage = () => {
        fetch('api/Data/GetPeticiones')
            .then(response => response.json())
            .then(data => {
                setdatapeticiones(data);
            });
    }

    const deleteGridDataPage = (valor, index) =>
    {

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Peticion);

            fetch('api/Data/EliminarPeticion', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res =>
            {
                if (res) {
                    //Si todo salie correcto limpio los valores de edicion                 
                    setdataeditando(valor);
                    setindexeditando(index);

                    if (datapeticiones != null) {
                        var array = [...datapeticiones]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        setdatapeticiones(array);
                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    const onclickColumna = (valor, field)=>
    {
        if (field == "ver") {

            setstateModal(DataStateModal.dsOpen);
            setitemmodal(valor);
            setmodomodal(field);            
        }
        else if (field == "alta") {
            if (valor != null && valor.tipo == TipoPeticion.Establecimiento)
            {
                var jsonData = JSON.stringify(valor.id_Peticion);

                fetch('api/Data/TramitarPeticion', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: jsonData

                }).then(response => response.json()).then(res => {
                    if (res) {
                        setLoading(true);                       
                        //getDataPage();
                    }
                }).catch(error => {
                    setalert(PopUpResult.KO);
                });

            }
        }
    }

    const othelloModalResul = (modo, result, valor) => {

        setstateModal(DataStateModal.dsClosed);
        setitemmodal(null);
        setmodomodal(null);        
    }

    const onClosePopUpResult = () => {
        setalert( null);
    }

    //METODOS DE RENDERIZADO DE LA PANTALLA

    function renderSearch(peticiones) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = idRol == Roles.SuperUsuario ? ["", "", "Peticion", "Tipo", "Nombre", "EMail", "Telefono", "Fecha Alta"] : ["", "", "Tipo", "Nombre", "EMail", "Telefono", "Fecha Alta"];
        let valoreshow = idRol == Roles.SuperUsuario ? ["ver", "alta", "id_Peticion", "tipo", "nombre", "eMail", "telefono", "fAlta"] : ["ver", "alta", "tipo", "nombre", "eMail", "telefono", "fAlta"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloDateTime, fieldname: "fAlta" });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "ver", icon: Visibility, onclick: onclickColumna });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "alta", icon: TouchApp, onclick: onclickColumna });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "tipo", items: TiposPeticion });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={peticiones} datasourcefields={datasourceFields} onDelete={deleteGridDataPage} />);
    }

    function renderModalPeticion(item, modo) {
        if (item != null)
            return (<OthelloModalBase titulo="Peticion" modo={ModoModal.SinDefinir} open={stateModal} onCloseResulModal={othelloModalResul} botones={MessageOthelloBoxButtons.OK} >
                <Peticion idpeticion={item.id_Peticion} onCloseResulModal={othelloModalResul} />
            </OthelloModalBase>)
        else
            return "";
    }


    let busqueda = loading ? <p><CircularProgress color="secondary" /></p> : renderSearch(datapeticiones)


    let modal = "";

    if (stateModal != DataStateModal.dsClosed)
        modal = renderModalPeticion(itemmodal, modomodal);

    let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    return (
        <Grid container>
            <Grid item xs={12} sm={12} md={12}>
                {modal}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                {alerta}
            </Grid>
            <Grid container>
                <Grid item xs={12} >
                    <OthelloBotonera statePage={statePage} />
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
                <OthelloTituloPanelData tituloliteral="_peticiones" margentop={0}>
                    <Grid container>
                        <Grid item xs={12}>
                            {busqueda}
                        </Grid>
                    </Grid>
                </OthelloTituloPanelData>
            </Grid>            
        </Grid>
    );
}

